import { gql } from "@apollo/client";

const ADD_OUNIT = gql`
  mutation addOUnit($oUnitData: OUnitInput!) {
    addOUnit(oUnitData: $oUnitData) {      
        abbreviation
        ounit_name{
          name
          language
        }
        ounit_contact{
          contact_names
          emails
        }
    }
  }
`;

export default ADD_OUNIT;
